import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "simple-modal-wrapper" }
const _hoisted_2 = { class: "simple-modal" }
const _hoisted_3 = { class: "simple-modal__content" }
const _hoisted_4 = { class: "simple-modal__heading" }
const _hoisted_5 = { class: "simple-modal__buttons" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "simple-modal__close",
        "aria-label": "Close modal",
        onClick: $setup.closeModal
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString($props.heading), 1 /* TEXT */),
        _renderSlot(_ctx.$slots, "content"),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "buttons")
        ])
      ])
    ])
  ]))
}